export default __webpack_public_path__ + "static/media/send.0fcf7ccd.svg";